import React, { useState, useEffect } from "react";
import {
  Tag,
  InputNumber,
  Input,
  Table,
  Modal,
  message,
  Button,
  Form,
  Image,
  Cascader,
  Upload,
  Select,
  DatePicker,
  Empty,
  Row,
  Col,
} from "antd";
const { Option } = Select;
const { TextArea } = Input;
import {
  UploadOutlined,
  PlusOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import InspectionApi from "@api/inspectionnew";
import { dictApi } from "@api/newApi";
import sysApi from "@api/sys";
import DepartmentApi from "@api/department";
import SearchForm from "@components/SearchForm";
import HandleButton from "@components/HandleButton";
import { connect } from "react-redux";
import moment from "moment";
import { getStationData, getOrderTreeData, toolMouseTip } from "@utils/common";
import AddModel from "./add";
import "../style.scss";
const { UPLOADER } = window.globalConfig;
const StatusData = ["待处理", "处理中", "完成", "关闭"];
const colorStatus = ["#FF3819", "#2db7f5", "#87d068", "#BDBDBD"];
// 外委工单审批状态
const assignStatus = ["", "审批中", "通过", "拒绝"];

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const layout1 = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 16,
  },
};
const InspectionCom = (props) => {
  const [resultForm] = Form.useForm();
  const [addSpcialForm] = Form.useForm();
  const [outsourForm] = Form.useForm();
  const [assignForm] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [handleSpecialForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadBtn] = useState(false);
  const [dataSource, setDataSource] = useState([]); // 表格数据
  const [deleteVisible, setDelVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [editTitle] = useState("新建工单");
  const [rowParams, setRowParams] = useState();
  const [detailModelVisible, setDetailModelVisible] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [resultId, setResultId] = useState();
  const [handleResultPicture, setHandleResultPicture] = useState([]);
  const [transferForm] = Form.useForm();
  const [detail, setDetail] = useState({});
  const [addSpcialModal, setAddSpcialModal] = useState(false);
  const [addSpcialWorkId, setAddSpcialWorkId] = useState();
  const [outsourModal, setOutsourModal] = useState(false);
  const [outsourWorkId, setOutsourWorkId] = useState();
  const [specialImages, setSpecialImages] = useState([]);
  const [tableTotal, setTableTotal] = useState(0);
  const [deptChildList, setDeptChildList] = useState([]);
  const [infoId, setInfoId] = useState();
  const [stationList, setStationList] = useState([]);
  const [deptRange, setDeptRange] = useState([]);
  const [searchUserRange, setSearchUserRange] = useState([]);
  const [detailImgVisi, setDetailImgVisi] = useState(false);
  const [detailHdImgVisi, setDetailHdImgVisi] = useState(false);
  const [addChildworkPid, setAddChildworkPid] = useState(null);
  const [submitWorkType, setSubmitWorkType] = useState("parent");
  const [deptList, setDeptList] = useState([]);
  const [personList, setPersonList] = useState([]);
  const [transferStationId, setTransferStationId] = useState("");
  const [addChildWorkDefectId, setAddChildWorkDefectId] = useState();
  const [infoTicketsImgs, setInfoTicketsImgs] = useState([]);
  const [infoTicketsHandImgs, setInfoTicketsHandImgs] = useState([]);
  const [delayModal, setDelayModal] = useState(false);
  const [delayTabLoading, setDelayTabLoading] = useState(false);
  const [delayTabData, setDelayTabData] = useState([]);
  // 指派
  const [assignId, setAssignId] = useState();
  const [assignModal, setAssignModal] = useState(false);
  // 特种作业票处理
  const [handleSpecial, setHandleSpecial] = useState(false);
  const [handleSpecialImages, setHandleSpecialImages] = useState([]);
  const [ticketId, setTicketId] = useState();
  const [specialtypeLs, setSpecialtypeLs] = useState([]);
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  // 转单弹出层
  const [transferVisibel, setTransferVisibel] = useState(false);
  const [transferId, setTransferId] = useState();
  const [timeLimit, setTimeLimit] = useState([]);

  useEffect(() => {
    getStationList();
    getDeptForTree();
  }, []);

  useEffect(() => {
    listByPages();
  }, [searchParams]);

  const getDeptForTree = () => {
    // 获取部门
    DepartmentApi.getDeptForTree({}).then((res) => {
      if (res.status !== "0") return;
      const dept = getTreeData(res.data);
      setDeptRange([...dept]);
    });
  };

  // 递归处理数据
  const getTreeData = (data) => {
    for (var i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        data[i].children = null;
        data[i].label = data[i].name;
        data[i].value = data[i].id;
      } else {
        data[i].label = data[i].name;
        data[i].value = data[i].id;
        getTreeData(data[i].children);
      }
    }
    return data;
  };

  // 获取厂站列表
  const getStationList = () => {
    let data = getStationData(
      props.userInfo.stationIds ? props.userInfo.stationIds : "-1",
      props.userInfo.stationAliasName,
    );
    setStationList(data);
  };

  const changeDept = (e) => {
    if (e) {
      let stationId = 0;
      if (searchForm.getFieldValue("stationId")) {
        stationId = searchForm.getFieldValue("stationId");
      }
      getSearchDeptUsers(stationId, e[e.length - 1]);
    } else {
      setSearchUserRange([]);
    }
  };

  const changeSeachStation = (e) => {
    if (e) {
      let deptId = 0;
      if (searchForm.getFieldValue("deptId")) {
        deptId =
          searchForm.getFieldValue("deptId")[
            searchForm.getFieldValue("deptId").length - 1
          ];
      }
      getSearchDeptUsers(e, deptId);
    } else {
      setSearchUserRange([]);
    }
  };

  const getSearchDeptUsers = (stationId, deptId) => {
    let params = { deptId };
    if (stationId) {
      params.stationId = stationId;
    }
    DepartmentApi.getDeptHeadersByDeptId(params).then((res) => {
      if (res.status !== "0") return;
      const list = res.data.map((item) => {
        return { title: item.realName, value: item.id };
      });
      setSearchUserRange([...list]);
    });
  };

  const listByPages = () => {
    setLoading(true);
    InspectionApi.workOrder({ ...searchParams }).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        setDataSource(getOrderTreeData(res.data?.data));
        setTableTotal(res.data?.total);
      }
    });
  };

  // 新增外委工单
  const submiteOutsour = () => {
    outsourForm.validateFields().then(async (values) => {
      if (!values) return;
      // 获取流程id
      const result = await sysApi.getFlowableId({
        dictType: "sw-flowable",
        dictKey: "patrol_work_order_assign_add",
      });
      if (result.status !== "0") return;
      const processId = result.data;
      InspectionApi.workOrderAssignAdd({
        ...values,
        workOrderId: outsourWorkId,
      }).then((res) => {
        if (res.status !== "0") return;
        InspectionApi.workOrderAssignEnable({ id: res.data, processId }).then(
          (v) => {
            message.success("新增成功");
            outsourForm.resetFields();
            setOutsourModal(false);
          },
        );
      });
    });
  };

  // 指派
  const submiteAssign = () => {
    assignForm.validateFields().then((values) => {
      if (!values) return;
      InspectionApi.workOrderSpecify({ ...values, id: assignId }).then(
        (res) => {
          if (res.status !== "0") return;
          message.success("指派成功");
          setAssignModal(false);
          assignForm.resetFields();
          listByPages();
        },
      );
    });
  };

  const closeOutsourModal = () => {
    outsourForm.resetFields();
    setOutsourModal(false);
  };

  // 新增特种作业票弹窗
  const addSpecialModal = (id) => {
    // 查询特种作业票类型
    dictApi
      .selectWithClassifyKey({ classifyKey: "specialOperateType" })
      .then((res) => {
        setSpecialtypeLs(res.data);
        setAddSpcialModal(true);
        setAddSpcialWorkId(id);
      });
  };

  // 新增特种作业票
  const subMiteSpacialForm = () => {
    addSpcialForm.validateFields().then((values) => {
      if (!values) return;
      values.beginTime = moment(values.beginTime).format("YYYY-MM-DD HH:mm:ss");
      if (specialImages.length == 0) return message.error("请上传处理照片");
      InspectionApi.workOrderTicketAdd({
        ...values,
        workOrderId: addSpcialWorkId,
        imageUrls: specialImages,
      }).then((res) => {
        if (res.status !== "0") return;
        message.success("新增成功");
        addSpcialForm.resetFields();
        setAddSpcialModal(false);
      });
    });
  };

  const closeAddSpcialModal = () => {
    addSpcialForm.resetFields();
    setAddSpcialModal(false);
  };

  // 关闭工单
  const closeWorker = (id) => {
    InspectionApi.workOrderClose({ id }).then((res) => {
      if (res.status !== "0") return;
      message.success("关闭成功");
      listByPages();
    });
  };

  // 查看工单详情
  const lookDetail = (id) => {
    setDetailModelVisible(true);
    InspectionApi.workOrderGetInfo({ id }).then((res) => {
      if (res.status !== "0") return;
      // 处理特种作业票图片
      if (res.data.tickets && res.data.tickets.length > 0) {
        let p = []; // 特种作业票照片数组控制显示与隐藏
        let ticketsHandImgs = []; // 特种作业票处理照片数组控制显示与隐藏
        res.data.tickets.forEach((item) => {
          if (item.imageUrls && item.imageUrls.length > 0) {
            item.imageUrls.forEach(() => {
              p.push(false);
            });
          }
          if (item.handleImageUrls && item.handleImageUrls.length > 0) {
            ticketsHandImgs.push(false);
          }
        });
        setInfoTicketsImgs(p);
        setInfoTicketsHandImgs(ticketsHandImgs);
      }
      setDetail(res.data);
    });
  };

  const submiteResult = () => {
    resultForm.validateFields().then((values) => {
      if (!values) return;
      InspectionApi.workOrderSubmit({
        ...values,
        id: resultId,
        handleImageUrls: handleResultPicture,
      }).then((res) => {
        if (res.status !== "0") return;
        message.success("提交成功");
        if (submitWorkType === "parent") {
          listByPages();
        } else {
          lookDetail(infoId);
        }
        resetSubmiteResult();
      });
    });
  };

  const resetSubmiteResult = () => {
    resultForm.resetFields();
    setHandleResultPicture([]);
    setResultModal(false);
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (values) => {
    const jsonParamsObj = JSON.parse(JSON.stringify(values));
    jsonParamsObj.deptId = jsonParamsObj.deptId
      ? jsonParamsObj.deptId[jsonParamsObj.deptId.length - 1]
      : "";
    let params = {
      ...jsonParamsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: jsonParamsObj.stationId && jsonParamsObj.stationId * 1,
    };
    setSearchParams(params);
  };

  // 工单催单
  const workOrderUrge = (id) => {
    InspectionApi.workOrderUrge({ id }).then((res) => {
      if (res.status === "0") {
        message.success("已催单");
      }
    });
  };

  const cancel = () => {
    setDelVisible(false);
    // setParams({})
  };

  const showAddChildModal = (record) => {
    const { defectOrderId, beginTime, endTime } = record;
    setAddChildworkPid(record.id);
    setAddChildWorkDefectId(defectOrderId);
    setTimeLimit([beginTime, endTime]);
    setEditVisible(true);
  };

  const btnList = [
    {
      title: "新增",
      type: "primary",
      visible:
        props.userInfo.btnResources.indexOf("work:order:add") !== -1
          ? true
          : false,
      icon: <PlusOutlined />,
      onClick: () => {
        setAddChildworkPid(null);
        setEditVisible(true);
        setRowParams(null);
      },
    },
  ];

  const delayColumns = [
    {
      title: "延期天数",
      dataIndex: "delayDays",
      align: "center",
      key: "delayDays",
    },
    {
      title: "延期说明",
      dataIndex: "delayDesc",
      align: "center",
      key: "delayDesc",
      render: (_t) => toolMouseTip(_t, 5),
    },
    {
      title: "延期关闭时间",
      dataIndex: "delayCloseTime",
      align: "center",
      key: "delayCloseTime",
      render: (_t) => moment(_t).format("YYYY-MM-DD HH:mm:ss"),
    },
  ];

  const columns = [
    {
      title: "工单标题",
      dataIndex: "workOrderTitle",
      align: "center",
      key: "workOrderTitle",
      render: (_t) => toolMouseTip(_t, 5),
    },
    {
      title: "所属场站",
      dataIndex: "stationAliasName",
      align: "center",
      key: "stationAliasName",
    },
    {
      title: "设备名称",
      dataIndex: "deviceRelevancyName",
      align: "center",
      key: "deviceRelevancyName",
    },
    {
      title: "处理人",
      dataIndex: "handleUserNames",
      align: "center",
      key: "handleUserNames",
    },
    {
      title: "实际处理人",
      dataIndex: "handleUserName",
      align: "center",
      key: "handleUserName",
    },
    {
      title: "状态",
      dataIndex: "status",
      align: "center",
      key: "status",
      render: (val) => (
        <Tag color={colorStatus[val - 0]}>{StatusData[val - 0]}</Tag>
      ),
    },
    {
      title: "超时状态",
      dataIndex: "timeoutStatus",
      align: "center",
      key: "timeoutStatus",
      render: (_t) =>
        _t == 1 ? (
          <Tag color="#FF3819">超时</Tag>
        ) : (
          <Tag color="#2db7f5">未超时</Tag>
        ),
    },
    {
      title: "开始时间",
      dataIndex: "beginTime",
      align: "center",
      key: "beginTime",
      render: (obj) => {
        if (obj) {
          return moment(obj).format("YYYY-MM-DD HH:mm:ss");
        }
      },
    },
    {
      title: "结束时间",
      dataIndex: "endTime",
      align: "center",
      key: "endTime",
      render: (obj) => {
        if (obj) {
          return moment(obj).format("YYYY-MM-DD HH:mm:ss");
        }
      },
    },
    {
      title: "操作",
      key: "operation",
      width: 450,
      render: (obj, record) => {
        return (
          <>
            {props.userInfo.btnResources.indexOf("work:order:info") !== -1 && (
              <Button
                size="small"
                type="primary"
                onClick={() => (lookDetail(record.id), setInfoId(record.id))}
              >
                详情
              </Button>
            )}
            {props.userInfo.btnResources.indexOf("work:order:transfer") !==
              -1 &&
              (record.handleUserNames || record.handleUserName) &&
              (record.status === 0 || record.status === 1) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => transferShow(record.id, record.stationId)}
                  style={{ marginLeft: "8px" }}
                >
                  转单
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("work:order:submit") !== -1 &&
              (record.status === 0 || record.status === 1) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => (
                    setResultId(record.id),
                    setResultModal(true),
                    setSubmitWorkType("parent")
                  )}
                  style={{ marginLeft: "8px" }}
                >
                  提交
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("work:order:urge") !== -1 &&
              (record.status == 1 || record.status == 0) &&
              (record.handleUserNames || record.handleUserName) && (
                <Button
                  size="small"
                  onClick={() => workOrderUrge(record.id)}
                  style={{ marginLeft: "8px" }}
                  type="primary"
                >
                  催单
                </Button>
              )}
            {/* {
              props.userInfo.btnResources.indexOf('work:order:specify') !== -1 &&
              (!record.handleUserNames && !record.handleUserName) && record.status === 0 && <Button size='small' type='primary' onClick={() => (assignModalShow(record.id, record.deptId, record.stationId))} style={{ marginLeft: '8px' }}>指派</Button>
            } */}
            {props.userInfo.btnResources.indexOf("work:order:close") !== -1 &&
              record.status !== 3 &&
              record.status !== 2 && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => closeWorker(record.id)}
                  style={{ marginLeft: "8px" }}
                >
                  关闭
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("work:order:ticket:add") !==
              -1 &&
              (record.status === 0 || record.status === 1) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => addSpecialModal(record.id)}
                  style={{ marginLeft: "8px" }}
                >
                  新增特种作业票
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("work:order:assign:add") !==
              -1 &&
              (record.status === 0 || record.status === 1) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => (
                    setOutsourModal(true),
                    setOutsourWorkId(record.id)
                  )}
                  style={{ marginLeft: "8px" }}
                >
                  新增外委工单
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("work:order:add") !== -1 &&
              (record.status === 0 || record.status === 1) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => showAddChildModal(record)}
                  style={{ marginLeft: "8px" }}
                >
                  新增子工单
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("work:order:delay:list") !==
              -1 &&
              (record.handleUserNames || record.handleUserName) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => showDelayDialog(record.id)}
                  style={{ marginLeft: "8px" }}
                >
                  延期记录
                </Button>
              )}
          </>
        );
      },
    },
  ];
  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === "image/jpg" ||
      file.type === "image/jpeg" ||
      file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("图片格式不正确!");
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error("图片最大7M!");
    }
    return isJpgOrPng && isLt2M;
  };

  const assignModalShow = (id, deptId, stationId) => {
    setAssignId(id);
    setAssignModal(true);
    DepartmentApi.getUsersByDeptId({ deptId, stationId }).then((res) => {
      if (res.status !== "0") return;
      setDeptChildList(res.data);
    });
  };

  const transferShow = async (id, stationId) => {
    // 查询部门
    const res = await DepartmentApi.getDeptForTree({});
    if (res.status !== "0") return;
    const dept = getTreeData(res.data);
    setDeptList(dept);
    setTransferVisibel(true);
    setTransferId(id);
    setTransferStationId(stationId);
  };

  // 切换部门查询部门负责人
  const changeTransferDept = (e) => {
    if (!e) return;
    let params = {
      deptId: e[e.length - 1],
      stationId: transferStationId,
      containDeptHeaders: 1,
    };
    DepartmentApi.getUsersByDeptId(params).then((res) => {
      if (res.status !== "0") return;
      setPersonList(res.data);
    });
  };

  // 延期记录弹窗
  const showDelayDialog = (id) => {
    setDelayTabLoading(true);
    InspectionApi.workOrderDelayList({ workId: id }).then((res) => {
      if (res.status === "0") {
        setDelayTabLoading(false);
        setDelayTabData(res.data);
      }
    });
    setDelayModal(true);
  };

  const uploadResultImg = (info) => {
    if (info.file.status === "done") {
      const { response: res } = info.file;
      if (res.status !== "0") return;
      setHandleResultPicture([...handleResultPicture, res.data.url]);
    }
  };

  const removeResultImg = (info) => {
    const { response: res } = info;
    const url = res.data.url;
    const params = handleResultPicture;
    const index = params.findIndex((item) => item === url);
    params.splice(index, 1);
    setHandleResultPicture([...params]);
  };

  const uploadSpecialImg = (info) => {
    const { file } = info;
    if (file.status === "done") {
      const { response: res } = info.file;
      if (res.status !== "0") return;
      setSpecialImages([...specialImages, res.data.url]);
    }
  };

  const uploadHandleSpecialImg = (info) => {
    const { file } = info;
    if (file.status === "done") {
      const { response: res } = info.file;
      if (res.status !== "0") return;
      setHandleSpecialImages([...handleSpecialImages, res.data.url]);
    }
  };

  const removeHandleSpecialImg = (info) => {
    const { response: res } = info;
    const url = res.data.url;
    const params = handleSpecialImages;
    const index = params.findIndex((item) => item === url);
    params.splice(index, 1);
    setHandleSpecialImages([...params]);
  };

  const removeSpeicalImg = (info) => {
    const { response: res } = info;
    const url = res.data.url;
    const params = specialImages;
    const index = params.findIndex((item) => item === url);
    params.splice(index, 1);
    setSpecialImages([...params]);
  };

  const closeTransfer = () => {
    transferForm.resetFields();
    setTransferVisibel(false);
  };

  const submitSpecialHanleResult = () => {
    handleSpecialForm.validateFields().then((values) => {
      const params = {
        handleResult: values.handleResult,
        ticketId: ticketId,
        handleImageUrls: handleSpecialImages,
      };
      InspectionApi.workOrderTicketSubmit(params).then((res) => {
        if (res.status !== "0") return;
        setHandleSpecial(false);
        message.success("提交成功");
        handleSpecialForm.resetFields();
        setHandleSpecialImages([]);
        lookDetail(infoId);
      });
    });
  };

  const closeSpecialHanleResult = () => {
    setHandleSpecial(false);
    handleSpecialForm.resetFields();
    setHandleSpecialImages([]);
  };

  // 提交转单
  const submiteTransfer = () => {
    transferForm.validateFields().then((values) => {
      if (!values) return;
      const params = {
        businessId: transferId,
        type: 0,
        ...values,
      };
      InspectionApi.workOrderTransfer(params).then((res) => {
        if (res.status !== "0") return;
        transferForm.resetFields();
        setTransferVisibel(false);
        message.success("转单成功");
        listByPages();
      });
    });
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        上传图片
      </div>
    </div>
  );

  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <div className="search-form">
            <Form
              onFinish={search}
              form={searchForm}
              labelCol={{ span: 9 }}
              wrapperCol={{ span: 15 }}
              layout="inline"
            >
              <Row style={{ width: "100%" }}>
                <Col span={8}>
                  <Form.Item
                    name="stationId"
                    label="厂站"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select
                      placeholder="请选择厂站"
                      onChange={changeSeachStation}
                      allowClear
                    >
                      {stationList.length > 0 &&
                        stationList.map((item) => {
                          return (
                            <Option value={item.value} key={item.value}>
                              {item.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="deptId"
                    label="负责部门"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Cascader
                      allowClear
                      options={deptRange}
                      onChange={changeDept}
                      placeholder="请选择负责部门"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="deptLeaderId"
                    label="部门负责人"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select placeholder="请选择部门负责人" allowClear>
                      {searchUserRange.length > 0 &&
                        searchUserRange.map((item) => {
                          return (
                            <Option value={item.value} key={item.value}>
                              {item.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="status"
                    label="状态"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select placeholder="请选择状态" allowClear>
                      <Option value={0}>待处理</Option>
                      <Option value={1}>处理中</Option>
                      <Option value={2}>完成</Option>
                      <Option value={3}>关闭</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="workOrderTitle"
                    label="工单标题"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input placeholder="请输入工单标题" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="workOrderContent"
                    label="工单内容"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input placeholder="请输入工单内容" />
                  </Form.Item>
                </Col>
                <Form.Item>
                  <Button
                    className="search-btn"
                    type="primary"
                    htmlType="submit"
                  >
                    搜索
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </div>
          {/* <SearchForm span={6} caderFirst={true} cascaderLs={cascaderLs} inputList={inputList} selectList={selectList} onSearch={search} /> */}
        </div>
        <HandleButton
          btnList={btnList}
          btnStyle={{ padding: "0 24px 20px", textAlign: "right" }}
        />
        <div>
          <Table
            className="Table"
            // scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={dataSource}
            rowKey={(record) => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (tableTotal) => `共${tableTotal}条数据`,
              total: tableTotal,
            }}
            childrenColumnName="child"
            indentSize={45}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        {deleteVisible && (
          <Modal
            title="详情"
            width={600}
            open={deleteVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={cancel}
          >
            <Form layout="horizontal">
              <Form.Item label="工单标题">{/* {rowParams.title} */}</Form.Item>
              <Form.Item label="所属场站">{rowParams.stationName}</Form.Item>
              <Form.Item label="工单状态">
                {StatusData[rowParams.status]}
              </Form.Item>
              <Form.Item label="工单内容">{rowParams.content}</Form.Item>
              <Form.Item label="处理结果">{rowParams.handleResult}</Form.Item>
              <Form.Item label="处理图片">
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {rowParams.images &&
                    JSON.parse(rowParams.images).map((v, i) => {
                      return (
                        <div style={{ margin: "0 5px 10px" }}>
                          <Image key={"simg" + i} width={100} src={v.url} />
                        </div>
                      );
                    })}
                </div>
              </Form.Item>
              <Form.Item label="创建时间">{rowParams.createAt}</Form.Item>
              <Form.Item label="更新时间">{rowParams.updateAt}</Form.Item>
            </Form>
          </Modal>
        )}
        {editVisible && (
          <AddModel
            defectOrderId={addChildWorkDefectId}
            pid={addChildworkPid}
            visible={editVisible}
            title={editTitle}
            timeLimit={timeLimit}
            cancel={(bool) => {
              setAddChildWorkDefectId(null);
              setEditVisible(false);
              bool && listByPages();
            }}
          />
        )}
      </div>
      {resultModal && (
        <Modal
          title="提交工单结果"
          open={resultModal}
          onOk={submiteResult}
          onCancel={resetSubmiteResult}
        >
          <Form form={resultForm} {...layout}>
            <Form.Item
              label="工单处理过程说明"
              name="handleResult"
              rules={[{ required: true, message: "请输入工单处理过程说明!" }]}
            >
              <Input placeholder="请输入工单处理过程说明" />
            </Form.Item>
            <Form.Item label="处理照片">
              <Upload
                name="file"
                action={UPLOADER}
                headers={{ authorization: sessionStorage.getItem("token") }}
                beforeUpload={(e) => beforeUpload(e)}
                onRemove={(e) => removeResultImg(e)}
                onChange={(e) => uploadResultImg(e)}
              >
                <Button icon={<UploadOutlined />}>上传图片</Button>
              </Upload>
            </Form.Item>
          </Form>
        </Modal>
      )}
      {/* 新增特种作业票 */}
      {addSpcialModal && (
        <Modal
          title="新增特种作业票"
          open={addSpcialModal}
          onCancel={closeAddSpcialModal}
          onOk={subMiteSpacialForm}
        >
          <Form {...layout1} form={addSpcialForm}>
            <Form.Item
              label="开始时间"
              name="beginTime"
              rules={[{ required: true, message: "请输入开始时间!" }]}
            >
              <DatePicker showTime />
            </Form.Item>
            <Form.Item
              label="特种作业类型"
              name="operateType"
              rules={[{ required: true, message: "请选择特种作业类型!" }]}
            >
              <Select placeholder="请输入特种作业类型">
                {specialtypeLs.length > 0 &&
                  specialtypeLs.map((item) => (
                    <Option value={item.id} key={item.id}>
                      {item.disName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="作业内容"
              name="operateContent"
              rules={[{ required: true, message: "请输入作业内容" }]}
            >
              <TextArea rows={3} placeholder="请输入作业内容"></TextArea>
            </Form.Item>
            <Form.Item
              label={
                <>
                  <em style={{ color: "red", paddingRight: 3 }}>*</em>处理照片
                </>
              }
            >
              <Upload
                name="file"
                action={window.globalConfig.UPLOADER}
                headers={{ authorization: sessionStorage.getItem("token") }}
                beforeUpload={(e) => beforeUpload(e)}
                onChange={(e) => uploadSpecialImg(e)}
                onRemove={(e) => removeSpeicalImg(e)}
              >
                <Button icon={<UploadOutlined />}>上传图片</Button>
              </Upload>
            </Form.Item>
          </Form>
        </Modal>
      )}
      {/* /新增特种作业票 */}
      {/* 新增工单外委 */}
      <Modal
        title="新增工单外委"
        open={outsourModal}
        onOk={submiteOutsour}
        onCancel={() => closeOutsourModal()}
      >
        <Form {...layout1} form={outsourForm} initialValues={{ planCost: 1 }}>
          {/* <Form.Item label="工单金额(元)" name="actualCost" rules={[{ required: true, message: '请输入工单金额' }]}>
            <InputNumber />
          </Form.Item> */}
          <Form.Item
            label="计划费用(元)"
            name="planCost"
            rules={[{ required: true, message: "请输入计划费用" }]}
          >
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item
            label="外委单位"
            name="assignUnit"
            rules={[{ required: true, message: "请输入外委单位" }]}
          >
            <Input placeholder="请输入外委单位" />
          </Form.Item>
          <Form.Item
            label="外委内容"
            name="assignContent"
            rules={[{ required: true, message: "请输入外委内容" }]}
          >
            <TextArea rows={3} placeholder="请输入外委内容"></TextArea>
          </Form.Item>
        </Form>
      </Modal>
      {/* /新增工单外委 */}
      <Modal
        title="转单"
        width={600}
        open={transferVisibel}
        onCancel={closeTransfer}
        onOk={submiteTransfer}
      >
        <Form
          name="basic"
          form={transferForm}
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 14,
          }}
          autoComplete="off"
          initialValues={{
            originalOperator: [],
          }}
        >
          {/* <Form.Item
            label="现操作人"
            name="currentOperator"
            rules={[
              {
                required: true,
                message: '请输入现操作人',
              },
            ]}
          >
            <Cascader allowClear options={users} showCheckedStrategy={Cascader.SHOW_CHILD} placeholder="请选择" />
          </Form.Item> */}
          <Form.Item
            label="负责部门"
            name="deptId"
            rules={[{ required: true, message: "请选择负责部门" }]}
          >
            <Cascader
              options={deptList}
              onChange={(e) => {
                changeTransferDept(e);
              }}
              placeholder="请选择"
            />
          </Form.Item>
          <Form.Item
            label="现操作人"
            name="currentOperator"
            rules={[{ required: true, message: "请选择现操作人" }]}
          >
            <Select placeholder="请选择现操作人">
              {personList.length > 0 &&
                personList.map((item) => {
                  return (
                    <Select.Option value={item.id} key={item.id}>
                      {item.realName}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        width={800}
        title="工单详情"
        open={detailModelVisible}
        onCancel={() => (setDetailModelVisible(false), setDetail({}))}
        onOk={() => (setDetailModelVisible(false), setDetail({}))}
      >
        <div className="defect-detail-td">
          <div className="defect-detail-title">{detail.workOrderTitle}</div>
          <div className="defect-detail-status">
            ●&nbsp;&nbsp;{StatusData[detail.status]}
          </div>
        </div>
        <div className="defect-detail-bd">
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">所属厂站</div>
            <div className="defect-detail-item-desc">
              {detail.stationAliasName}
            </div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">设备名</div>
            <div className="defect-detail-item-desc">
              {detail.deviceRelevancyName}
            </div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">处理人</div>
            <div className="defect-detail-item-desc">
              {detail.handleUserNames}
            </div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">实际处理人</div>
            <div className="defect-detail-item-desc">
              {detail.handleUserName}
            </div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">开始时间</div>
            <div className="defect-detail-item-desc">{detail.beginTime}</div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">结束时间</div>
            <div className="defect-detail-item-desc">{detail.endTime}</div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">超时状态</div>
            <div className="defect-detail-item-desc">
              {detail.timeoutStatus == 1 ? "超时" : "未超时"}
            </div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">工单内容</div>
            <div className="defect-detail-item-desc">
              {detail.workOrderContent}
            </div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">关联缺陷描述</div>
            <div className="defect-detail-item-desc">
              {detail.deffectRemark}
            </div>
          </div>
          <div className="defect-detail-bd-item">
            <div className="defect-detail-item-lable">处理结果</div>
            <div className="defect-detail-item-desc">{detail.handleResult}</div>
          </div>
          <div className="defect-detail-bd-img">
            <div className="defect-detail-item-lable">工单图片展示</div>
            {detail.imageUrls && detail.imageUrls.length > 0 ? (
              <div className="defect-detail-item-imglist">
                <Image
                  preview={{
                    visible: false,
                  }}
                  width={200}
                  src={detail.imageUrls[0]}
                  onClick={() => setDetailImgVisi(true)}
                />

                <div style={{ display: "none" }}>
                  <Image.PreviewGroup
                    preview={{
                      visible: detailImgVisi,
                      onVisibleChange: (vis) => setDetailImgVisi(vis),
                    }}
                  >
                    {detail.imageUrls.map((item, index) => {
                      return <Image src={item} key={index} />;
                    })}
                  </Image.PreviewGroup>
                </div>
              </div>
            ) : (
              <Empty description="暂无图片" />
            )}
          </div>
          <div className="defect-detail-bd-img">
            <div className="defect-detail-item-lable">处理图片展示</div>
            {detail.handleImageUrls && detail.handleImageUrls.length > 0 ? (
              <div className="defect-detail-item-imglist">
                <Image
                  preview={{
                    visible: false,
                  }}
                  width={200}
                  src={detail.handleImageUrls[0]}
                  onClick={() => setDetailHdImgVisi(true)}
                />

                <div style={{ display: "none" }}>
                  <Image.PreviewGroup
                    preview={{
                      visible: detailHdImgVisi,
                      onVisibleChange: (vis) => setDetailHdImgVisi(vis),
                    }}
                  >
                    {detail.handleImageUrls.map((item, index) => {
                      return <Image src={item} key={index} />;
                    })}
                  </Image.PreviewGroup>
                </div>
              </div>
            ) : (
              <Empty description="暂无图片" />
            )}
          </div>
        </div>
        <div className="defect-details-list">
          <div className="defect-details-list-item">
            <div className="defect-details-list-item-td">
              <div className="defect-detail-item-lable">外委工单</div>
            </div>
            {detail.assigns &&
              detail.assigns.length > 0 &&
              detail.assigns.map((item) => {
                return (
                  <div className="defect-details-list-item-bd" key={item.id}>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        外委内容
                      </div>
                      <div className="defect-details-item-content-text">
                        {item.assignContent}
                      </div>
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        审批状态
                      </div>
                      <div className="defect-details-item-content-text">
                        {assignStatus[item.approvalStatus]}
                      </div>
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        外委单位
                      </div>
                      <div className="defect-details-item-content-text">
                        {item.assignUnit}
                      </div>
                    </div>
                    {/* <div className='defect-details-item-content'>
                          <div className='defect-details-item-content-label'>外委金额</div>
                          <div className='defect-details-item-content-text'>{item.actualCost}</div>
                        </div> */}
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        计划费用
                      </div>
                      <div className="defect-details-item-content-text">
                        {item.planCost}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="defect-details-list-item">
            <div className="defect-details-list-item-td">
              <div className="defect-detail-item-lable">特种作业票</div>
            </div>
            {detail.tickets &&
              detail.tickets.length > 0 &&
              detail.tickets.map((item, index) => {
                return (
                  <div className="defect-details-list-item-bd" key={item.id}>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        作业内容
                      </div>
                      <div className="defect-details-item-content-text">
                        {toolMouseTip(item.operateContent, 6)}
                      </div>
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        状态
                      </div>
                      <div className="defect-details-item-content-text">
                        {StatusData[item.handleStatus]}
                      </div>
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        开始时间
                      </div>
                      <div className="defect-details-item-content-text">
                        {item.beginTime
                          ? moment(item.beginTime).format("YYYY-MM-DD HH:mm:ss")
                          : "-"}
                      </div>
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        作业类型
                      </div>
                      <div className="defect-details-item-content-text">
                        {item.operateTypeName}
                      </div>
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        处理结果
                      </div>
                      <div className="defect-details-item-content-text">
                        {item.handleResult}
                      </div>
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        照片
                      </div>
                      {item.imageUrls && item.imageUrls.length > 0 ? (
                        <div className="defect-detail-item-imglist">
                          <Image
                            preview={{
                              visible: false,
                            }}
                            width={100}
                            src={item.imageUrls[0]}
                            onClick={() => {
                              let p = infoTicketsImgs;
                              p[index] = true;
                              setInfoTicketsImgs([...p]);
                            }}
                          />

                          <div style={{ display: "none" }}>
                            <Image.PreviewGroup
                              preview={{
                                visible: infoTicketsImgs[index],
                                onVisibleChange: (vis) => {
                                  let p = infoTicketsImgs;
                                  p[index] = vis;
                                  setInfoTicketsImgs([...p]);
                                },
                              }}
                            >
                              {item.imageUrls.map((item, index) => {
                                return <Image src={item} key={index} />;
                              })}
                            </Image.PreviewGroup>
                          </div>
                        </div>
                      ) : (
                        "暂无图片"
                      )}
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        处理照片
                      </div>
                      {item.handleImageUrls &&
                      item.handleImageUrls.length > 0 ? (
                        <div className="defect-detail-item-imglist">
                          <Image
                            preview={{
                              visible: false,
                            }}
                            width={100}
                            src={item.handleImageUrls[0]}
                            onClick={() => {
                              let p = infoTicketsHandImgs;
                              p[index] = true;
                              setInfoTicketsHandImgs([...p]);
                            }}
                          />

                          <div style={{ display: "none" }}>
                            <Image.PreviewGroup
                              preview={{
                                visible: infoTicketsHandImgs[index],
                                onVisibleChange: (vis) => {
                                  let p = infoTicketsHandImgs;
                                  p[index] = vis;
                                  setInfoTicketsHandImgs([...p]);
                                },
                              }}
                            >
                              {item.handleImageUrls.map((item, index) => {
                                return <Image src={item} key={index} />;
                              })}
                            </Image.PreviewGroup>
                          </div>
                        </div>
                      ) : (
                        "暂无图片"
                      )}
                    </div>
                    <div className="defect-details-item-content">
                      <div className="defect-details-item-content-label">
                        操作
                      </div>
                      <div className="defect-details-item-content-text">
                        {props.userInfo.btnResources.indexOf(
                          "work:order:ticket:submit",
                        ) !== -1 &&
                          detail.status !== 3 &&
                          item.handleStatus == 1 && (
                            <Tag
                              color="#2D99FF"
                              onClick={() => (
                                setHandleSpecial(true),
                                setTicketId(item.id)
                              )}
                            >
                              提交
                            </Tag>
                          )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </Modal>

      {/* 特种作业票处理 */}
      <Modal
        title="特种作业票处理"
        open={handleSpecial}
        onCancel={() => closeSpecialHanleResult()}
        onOk={() => submitSpecialHanleResult()}
      >
        <Form
          name="basic"
          form={handleSpecialForm}
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 14,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="执行结果"
            name="handleResult"
            rules={[
              {
                required: true,
                message: "请输入执行结果",
              },
            ]}
          >
            <TextArea placeholder="请输入执行结果" />
          </Form.Item>
          <Form.Item label="上传图片">
            <Upload
              name="file"
              action={window.globalConfig.UPLOADER}
              headers={{ authorization: sessionStorage.getItem("token") }}
              beforeUpload={(e) => beforeUpload(e)}
              onChange={(e) => uploadHandleSpecialImg(e)}
              onRemove={(e) => removeHandleSpecialImg(e)}
            >
              <Button icon={<UploadOutlined />}>上传图片</Button>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>

      {/* /特种作业票处理 */}

      {/* 指派 */}
      <Modal
        title="指派"
        width={600}
        open={assignModal}
        onCancel={() => setAssignModal(false)}
        onOk={() => submiteAssign()}
      >
        <Form
          name="basic"
          form={assignForm}
          labelCol={{
            span: 4,
          }}
          wrapperCol={{
            span: 14,
          }}
          autoComplete="off"
        >
          <Form.Item
            label="候选执行人"
            name="handleUserIds"
            rules={[
              {
                required: true,
                message: "请输入候选执行人",
              },
            ]}
          >
            <Select
              mode="multiple"
              style={{
                width: 300,
              }}
              placeholder="请选择部门负责人"
            >
              {deptChildList.length > 0 &&
                deptChildList.map((item) => {
                  return (
                    <Select.Option value={item.id} key={item.id}>
                      {item.realName}
                    </Select.Option>
                  );
                })}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
      {/* 延期记录 */}
      <Modal
        title="延期记录"
        open={delayModal}
        onCancel={() => setDelayModal(false)}
        onOk={() => setDelayModal(false)}
      >
        <Table
          columns={delayColumns}
          dataSource={delayTabData}
          rowKey={(record) => record.id}
          loading={delayTabLoading}
          pagination={false}
        />
      </Modal>
      {/* /延期记录 */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(InspectionCom);
